var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"loading":_vm.categoriesLoading,"items":_vm.propCategories,"flat":"","multiple":"","chips":"","deletable-chips":"","label":"Select Categories","item-text":"name","item-value":"id"},model:{value:(_vm.selectedCategories),callback:function ($$v) {_vm.selectedCategories=$$v},expression:"selectedCategories"}})
}
var staticRenderFns = []

export { render, staticRenderFns }